type DocumentDepositLabelOptions = {
  depositType?: string | null;
  depositValue?: number | string | null;
  /** Wording the surface uses; the percentage is appended to it. */
  label?: string;
};

function formatPercent(value: number): string {
  return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;
}

/**
 * Name the deposit, STATING the percentage when that is the term of the offer.
 *
 * A percentage deposit is a term the customer agreed to, not just an amount:
 * "50% of the total" and "$5,000.00" say different things, and a document that
 * prints only the dollar figure loses the half of the offer that survives a
 * change in scope. So the percentage rides in the label and the money stays the
 * value — the same split `documentDiscountLabel` uses for a percentage
 * discount, one directory over.
 *
 * A FLAT deposit has no second term to state: its value IS the money, which the
 * surface already prints. Same for a legacy row with no stated type, whose
 * `depositValue` charges nothing at all (see the deposit engine's typeless
 * branch) — appending it would print a number the customer is not being asked
 * for.
 */
export function documentDepositLabel({
  depositType,
  depositValue,
  label = 'Deposit',
}: DocumentDepositLabelOptions): string {
  const value = Number(depositValue) || 0;
  return depositType === 'PERCENT' && value > 0 ? `${label} (${formatPercent(value)})` : label;
}
